import React from 'react';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './InProgButton.module.css';
import { CommonButton } from '_components';


export class RedoButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : ''} onClick={this.props.onClick} size={this.props.size} className={cls} type='round' >
                <FontAwesomeIcon icon={faRedoAlt} transform="flip-h" color="#555" />
            </CommonButton>
        );
    }
}

